"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ServerDateUtils = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var ServerDateUtils = /** @class */ (function () {
    function ServerDateUtils() {
    }
    // static TIMEZONE = 'Asia/Calcutta';
    ServerDateUtils.getCurrentTimeStamp = function () {
        return Date.now();
        // return moment().tz(DateUtils.TIMEZONE).valueOf();
    };
    ServerDateUtils.getCurrentTimeInGivenFormat = function (format) {
        if (format === void 0) { format = 'MMM D, YYYY'; }
        // return "moment().format(format)";
        var currentTimeStamp = Date.now();
        return (0, moment_timezone_1["default"])().format(format);
    };
    ServerDateUtils.getTimeInGivenFormat = function (date, format) {
        if (format === void 0) { format = 'MMM D, YYYY'; }
        return (0, moment_timezone_1["default"])(date).format(format);
    };
    return ServerDateUtils;
}());
exports.ServerDateUtils = ServerDateUtils;
